import { motion } from 'framer-motion';
import styled from 'styled-components';

export const AssetWrapper = styled(motion.div)`
    &&& {
        max-height: 100%;
        width: 100%;

        img,
        video {
            max-height: 100%;
            width: 100%;
            border-radius: 10px;
            user-drag: none;
        }
    }
`;

interface Props {
    $loaded?: boolean;
}

export const NFTWrapper = styled(motion.div).attrs<Props>(({ $loaded }) => ({
    style: { aspectRatio: !$loaded && '1 / 1' },
}))<Props>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
`;
